<template>
<section class="content">
  <h2>BOOKING CONFIRMATION VIEW</h2>
</section>
</template>